import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { LinkExternal } from "./LinkExternal/LinkExternal";

export const makeLinkExternalLabel = (data: MakeLabelParams) => (
  <LinkExternal params={data} />
);
